export const LIVE = '/live'
export const LIVE_IMAGE = `${LIVE}/image`
